import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '@/components/atoms/Button';

/**
 * 에러 페이지 공통 셸 — 404/403/500 에서 재사용.
 *  - 시세공간 톤: 흰 배경 + primary 강조, 둥근 카드
 *  - 모바일 우선: 가로 패딩 충분, 큰 글씨, 단일 컬럼
 *  - 헤더/푸터 없이 단독 렌더 (DefaultLayout 바깥에서 사용)
 */
export function ErrorShell({
  code,
  title,
  description,
  hint,
}: {
  /** 표시용 상태 코드 (404 / 403 / 500) — 단지 시각적 라벨 */
  code: string;
  title: string;
  description: string;
  /** 추가 안내 (선택) */
  hint?: string;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-white to-[#eff6ff] px-6 py-12">
      <div className="w-full max-w-md text-center">
        <p
          className="select-none text-[clamp(72px,18vw,128px)] font-extrabold leading-none tracking-tight text-[var(--color-primary)]"
          aria-hidden
        >
          {code}
        </p>
        <h1 className="mt-2 text-2xl font-bold text-[var(--color-text)] md:text-3xl">
          {title}
        </h1>
        <p className="mt-3 text-sm text-[var(--color-text-sub)] md:text-base">
          {description}
        </p>
        {hint && (
          <p className="mt-2 text-xs text-[var(--color-text-sub)]">{hint}</p>
        )}
        <div className="mt-8 flex flex-col items-center gap-2">
          <Link to="/">
            <Button size="lg">
              <Home className="h-4 w-4" />
              홈으로 가기
            </Button>
          </Link>
          <button
            type="button"
            onClick={() => window.history.length > 1 && window.history.back()}
            className="text-xs text-[var(--color-text-sub)] underline-offset-2 hover:underline"
          >
            이전 페이지로 돌아가기
          </button>
        </div>
      </div>
    </div>
  );
}
